<template>
  <div>
    <fieldset
      class="flex flex-col lg:flex-row items-start lg:items-center gap-x-6 xl:gap-x-8 text-los-blue-darkest xl:text-lg"
    >
      <legend class="hidden lg:contents text-xl font-medium">
        Sorteer op:
      </legend>
      <div class="hidden lg:flex items-center gap-x-4 lg:gap-x-6 flex-wrap">
        <div
          class="flex items-center group shrink-0 font-medium"
          v-for="(option, index) in sortOptions"
          :key="index"
        >
          <input
            :value="option.key"
            type="radio"
            :id="option.key"
            v-model="sortFilter"
            class="accent-[#208084] cursor-pointer"
            :name="`sort-${index}`"
            @change="onChange"
          />
          <label
            class="pl-2 transition-all cursor-pointer"
            :class="{
              'text-los-blue-darkest': sort === option.key,
              'group-hover:underline': sort != option.key,
            }"
            :for="option.key"
            >{{ option.name }}</label
          >
        </div>
      </div>
    </fieldset>
    <div class="grid lg:hidden grid-cols-2 w-full gap-x-2">
      <div class="col-span-1 h-10 relative">
        <label
          class="flex items-center justify-center w-full h-full bg-los-blue-lightest uppercase tracking-wide text-los-darker-gray text-xs md:text-sm font-bold rounded-md shadow-sm"
          for="mobile-sort"
        >
          Sorteren
          <FontAwesome class="ml-1 mb-1" icon="chevron-down" />
        </label>
        <select
          class="absolute inset-0 opacity-0 w-full"
          v-model="sortFilter"
          @change="onChange"
          id="mobile-sort"
        >
          <option
            v-for="(option, index) in sortOptions"
            :key="index"
            :value="option.key"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="col-span-1 h-10 relative flex gap-x-2">
        <button
          class="flex items-center justify-center flex-1 h-full bg-los-blue-lightest uppercase tracking-wide text-los-darker-gray text-xs md:text-sm font-bold rounded-md shadow-sm"
          @click="$emit('onClickFilter')"
        >
          Filteren
        </button>
        <button
          v-if="canResetFilters"
          class="w-10 h-full bg-los-blue-dark text-white rounded-md"
          @click="$emit('onReset')"
        >
          <FontAwesome icon="rotate-left" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  sort: {
    type: String,
    default: 'order:asc',
  },
  canResetFilters: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['onChange', 'onClickFilter', 'onReset']);

const sortOptions = [
  {
    key: 'order:asc',
    name: 'Relevantie',
  },
  {
    key: 'name:asc',
    name: 'A-Z',
  },
  {
    key: 'price:asc',
    name: 'Prijs (oplopend)',
  },
  {
    key: 'price:desc',
    name: 'Prijs (aflopend)',
  },
];

const sortFilter = computed({
  get() {
    return props.sort;
  },
  set(v) {
    return v;
  },
});

function onChange(e) {
  const { value } = e.target;
  emit('onChange', { key: 'sort', value });
}
</script>

<style lang="scss" scoped></style>
